/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { qs } from 'url-parse';
import { DEFAULT_MATCH, DEFAULT_ROUTE } from '../../constants.tsx';
import type {
	Query,
	Route,
	Routes,
	RouterContext,
	CreateRouterContextOptions,
	FindRouterContextOptions,
} from '../../types.tsx';
import { generatePath } from '../generate-path/generatePath.tsx';
import matchRoute from '../match-route/matchRoute.tsx';

export const createRouterContext = (
	route: Route,
	options: CreateRouterContextOptions = {},
): RouterContext => {
	const { params = {}, query = {}, basePath = '' } = options;
	const pathname = generatePath(route.path, params);
	const matchedRoute = matchRoute([route], pathname, query, basePath);

	return {
		route,
		match: matchedRoute ? matchedRoute.match : DEFAULT_MATCH,
		query,
	};
};

export const findRouterContext = <R extends Route = Route>(
	routes: Routes,
	options: FindRouterContextOptions,
): RouterContext<R> => {
	const { location, basePath = '' } = options;
	const { pathname, search } = location;
	const query = qs.parse(search) as Query;
	const matchedRoute = matchRoute(routes, pathname, query, basePath);

	return {
		query,
		route: (matchedRoute ? matchedRoute.route : DEFAULT_ROUTE) as R,
		match: matchedRoute ? matchedRoute.match : DEFAULT_MATCH,
	};
};
